import { render, staticRenderFns } from "./UtilHitCard.vue?vue&type=template&id=271c5a99&scoped=true"
import script from "./UtilHitCard.vue?vue&type=script&lang=js"
export * from "./UtilHitCard.vue?vue&type=script&lang=js"
import style0 from "./UtilHitCard.vue?vue&type=style&index=0&id=271c5a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c5a99",
  null
  
)

export default component.exports